import styled from "styled-components";
import { AutosizeInput } from "@similarweb/ui-components";
import { LinkButton } from "@similarweb/ui-components";

export const WidgetTitleWrapper = styled.div<{ titlePaddingBottom?: string }>`
    ${({ titlePaddingBottom = "15px" }) => `
        display: inline-flex;
        paddingBottom: ${titlePaddingBottom};
    `}
`;
export const WidgetTitleLinkWrapper = styled(LinkButton)<{ isVisible: boolean }>`
    display: ${({ isVisible }) => (isVisible ? "block" : "none")};
`;
export const WidgetTitleInputWrapper = styled(AutosizeInput)<{ isVisible: boolean }>`
    display: ${({ isVisible }) => (isVisible ? "block" : "none")};
`;
export const TableCompareTitleWrapper = styled.div`
    display: block;
    padding: 12px 0 7px 12px;
    margin-bottom: 0;
`;
